import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faArrowsUpDownLeftRight,
  faArrowUp,
  faBell,
  faCheckCircle,
  faDownload,
  faEdit,
  faExclamationCircle,
  faExclamationTriangle,
  faFile,
  faFolder,
  faHome,
  faPalette,
  faRotateRight,
  faTrash,
  faUpload,
  faWrench
} from '@fortawesome/free-solid-svg-icons'

// Add icons to the library
library.add(
  faHome,
  faFolder,
  faFile,
  faDownload,
  faEdit,
  faTrash,
  faArrowUp,
  faUpload,
  faBell,
  faExclamationTriangle,
  faCheckCircle,
  faExclamationCircle,
  faWrench,
  faRotateRight,
  faArrowsUpDownLeftRight,
  faPalette
)

export { FontAwesomeIcon }
